import React, {Component} from 'react'
import {Media, Tooltip} from 'reactstrap'
import GoogleMapReact from 'google-map-react'
import {fitBounds} from 'google-map-react/utils'
import {MAPS_API_KEY} from "../../api"
import {NEW_MAPS_API_KEY} from "../../api"
import MapPoint from "../../images/map-point.png"
import MapPointHover from "../../images/map-point-hover.png"
import MapPointActive from "../../images/map-point-active.png"
import MapIcon from "react-icons/lib/fa/map"
import '../../stylesheets/ControllerMap.css'

const ControllerPin = ({onMouseOver, onMouseOut, onClick, onMouseDown, onMouseUp, active, hover, id, tooltipText}) => {
    let mapPointImg = MapPoint
    let currentClassName = "map-point m0 p0"
    if (active) {
        mapPointImg = MapPointActive
    } else if (hover) {
        mapPointImg = MapPointHover
        currentClassName = "map-point m0 p0 spin"
    }

    return <a href="javascript:void(0)"
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut}
              onClick={onClick}
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}>
        <div className={currentClassName} id={id}>
            <Media object src={mapPointImg} width={36}/>
        </div>
        <Tooltip placement="top" isOpen={hover || active} target={`${id}`} toggle={(e) => void(e)}>
            {tooltipText}
        </Tooltip>
    </a>
}

const calculateCenterAndZoom = (controllers, width, height) => {
    let locations = controllers.map((c) => c.lastKnownLocation).filter((l) => l && !isNaN(parseFloat(l.latitude)) &&
        !isNaN(parseFloat(l.longitude)) &&
        !(parseFloat(l.latitude) === 0 &&
            parseFloat(l.longitude) === 0))
    let lats = locations.map((l) => parseFloat(l.latitude))
    let lons = locations.map((l) => parseFloat(l.longitude))
    let minLat = Math.min(...lats)
    let maxLat = Math.max(...lats)
    let minLon = Math.min(...lons)
    let maxLon = Math.max(...lons)
    let bounds = {
        nw: {
            lat: maxLat,
            lng: minLon
        },
        se: {
            lat: minLat,
            lng: maxLon
        },
    }
    let size = {width, height}

    let result = fitBounds(bounds, size)
    if (result.center && !isNaN(result.center.lat) && !isNaN(result.center.lng)) {
        return result
    } else {
        result.center = {lat: 0, lng: 0}
        result.zoom = 12
        return result
    }
}


export default class ControllerMap extends Component {

    controllerClickHandler = (controller) => () => {
        this.onControllerClick(controller)
    }

    controllerMouseOverHandler = (controller) => () => {
        this.setState({highlightedController: controller.id})
        this.onControllerMouseOver(controller)
    }

    controllerMouseOutHandler = (controller) => () => {
        this.setState({highlightedController: -1})
        this.onControllerMouseOut(controller)
    }

    controllerMouseDownHandler = (controller) => () => {
        this.setState({activeController: controller.id})
    }

    controllerMouseUpHandler = () => () => {
        this.setState({activeController: -1})
    }

    constructor(props) {
        super(props)
        let {controllers, highlightedController, centerOnController, onControllerClick, onControllerMouseOver, onControllerMouseOut} = this.props

        this.onControllerClick = onControllerClick
        this.onControllerMouseOver = onControllerMouseOver
        this.onControllerMouseOut = onControllerMouseOut

        controllers = controllers || []
        highlightedController = highlightedController || -1
        let filteredControllers = controllers.filter((c) => c.lastKnownLocation && !isNaN(parseFloat(c.lastKnownLocation.latitude)) && !isNaN(parseFloat(c.lastKnownLocation.longitude)))
        centerOnController = centerOnController || !filteredControllers.length || filteredControllers.length < 2

        let lng = 0
        let lat = 0

        if (controllers.length && controllers[0].lastKnownLocation && !isNaN(parseFloat(controllers[0].lastKnownLocation.latitude)) && !isNaN(parseFloat(controllers[0].lastKnownLocation.longitude))) {
            lng = parseFloat(controllers[0].lastKnownLocation.longitude)
            lat = parseFloat(controllers[0].lastKnownLocation.latitude)
        }

        let width = 640
        let height = 320
        if (this.mapContainer) {
            width = this.mapContainer.clientWidth
            height = this.mapContainer.clientHeight
        }
        let {center, zoom} = calculateCenterAndZoom(controllers, width, height)
        if (centerOnController && controllers.length && controllers[0].lastKnownLocation) {
            zoom = 12
            center = {lat: parseFloat(lat), lng: parseFloat(lng)}
        }

        this.state = {
            highlightedController,
            filteredControllers,
            centerOnController,
            center,
            zoom,
            activeController: -1
        }

        this.controllerClickHandler = this.controllerClickHandler.bind(this)
        this.controllerMouseOverHandler = this.controllerMouseOverHandler.bind(this)
        this.controllerMouseOutHandler = this.controllerMouseOutHandler.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let {controllers, highlightedController, centerOnController, onControllerClick, onControllerMouseOver, onControllerMouseOut} = nextProps
        this.onControllerClick = onControllerClick
        this.onControllerMouseOver = onControllerMouseOver
        this.onControllerMouseOut = onControllerMouseOut

        highlightedController = highlightedController || -1
        let filteredControllers = controllers.filter((c) => c.lastKnownLocation && !isNaN(parseFloat(c.lastKnownLocation.latitude)) && !isNaN(parseFloat(c.lastKnownLocation.longitude)))
        centerOnController = centerOnController || !filteredControllers.length || filteredControllers.length < 2

        let lng = 0
        let lat = 0

        if (controllers.length && controllers[0].lastKnownLocation && !isNaN(parseFloat(controllers[0].lastKnownLocation.latitude)) && !isNaN(parseFloat(controllers[0].lastKnownLocation.longitude))) {
            lng = parseFloat(controllers[0].lastKnownLocation.longitude)
            lat = parseFloat(controllers[0].lastKnownLocation.latitude)
        }

        let width = 640
        let height = 320
        if (this.mapContainer) {
            width = this.mapContainer.clientWidth
            height = this.mapContainer.clientHeight
        }

        let {center, zoom} = this.state
        if (filteredControllers.length !== this.state.filteredControllers.length) {
            let {newCenter, newZoom} = calculateCenterAndZoom(controllers, width, height)
            if (centerOnController && controllers.length && controllers[0].lastKnownLocation) {
                newZoom = 12
                newCenter = {lat: parseFloat(lat), lng: parseFloat(lng)}
            }
            center = newCenter
            zoom = newZoom
        }
        this.setState({
            highlightedController,
            filteredControllers,
            centerOnController,
            center,
            zoom
        })

    }

    onChange({center, zoom}) {
        this.setState({center, zoom})
    }

    render() {
        let {activeController, highlightedController, filteredControllers, center, zoom} = this.state
        return (filteredControllers && filteredControllers.length ?
                <div className="controller-map" ref={(c) => this.mapContainer = c}>
                    <GoogleMapReact
                        bootstrapURLKeys={{
                            key: NEW_MAPS_API_KEY,
                        }}
                        center={center}
                        zoom={zoom}
                        onChange={this.onChange}
                        options={{mapTypeId: 'satellite'}}>
                        {filteredControllers.map((con, idx) =>
                            (con.lastKnownLocation && !isNaN(parseFloat(con.lastKnownLocation.latitude)) && !isNaN(parseFloat(con.lastKnownLocation.longitude)) ?
                                <ControllerPin lat={parseFloat(con.lastKnownLocation.latitude)}
                                               lng={parseFloat(con.lastKnownLocation.longitude)}
                                               key={`${con.id}-${idx}-${con.lastKnownLocation.latitude}-${con.lastKnownLocation.longitude}`}
                                               id={`con-img-${idx}`}
                                               onMouseOver={this.controllerMouseOverHandler(con)}
                                               onMouseOut={this.controllerMouseOutHandler(con)}
                                               onClick={this.controllerClickHandler(con)}
                                               onMouseDown={this.controllerMouseDownHandler(con)}
                                               onMouseUp={this.controllerMouseUpHandler(con)}
                                               active={activeController === con.id}
                                               hover={highlightedController === con.id}
                                               tooltipText={con.userIdentifiableName}/>
                                : null)
                        )}
                    </GoogleMapReact>
                </div> :
                    <div className="text-muted bg-muted-sf-orange border-top-light-sf-orange p-2">
                        <strong><MapIcon/>&ensp;No Location Data Available.</strong>
                    </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/ControllerMap.js